import { Flex } from '@mantine/core';
import { ContentPlaceholder } from '../../../../components/content-placeholder/content-placeholder';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { useSelectedCapacityTeams } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { useAutoSelectFilters } from '../../filters/capacity/capacity.hooks';
import { useCapacityData } from '../../hooks/capacity';
import { Tab } from '../../process-analysis.type';
import { CapacityTable } from './table/table';

export const Capacity = () => {
  const selectedCapacityTeams = useSelectedCapacityTeams();
  const activeTab = useProcessAnalysisStore((state) => state.activeTab);

  const { portfolioData, projectData, isFetching } = useCapacityData();

  useAutoSelectFilters();

  if (!isFetching && (!projectData || Object.keys(projectData).length === 0)) {
    return <ContentPlaceholder />;
  }

  if (activeTab === Tab.Portfolios && selectedCapacityTeams.length === 0) {
    return <ContentPlaceholder noFiltersApplied />;
  }

  return (
    <Flex direction="column" h="100%" w="100%" pos="relative">
      <CapacityTable portfolioData={portfolioData} projectData={projectData} />
    </Flex>
  );
};
